export interface TaxBracketSource {
  total_tax_8?: number;
  total_tax_10?: number;
  tax_amount_8?: number;
  tax_amount_10?: number;
}

export interface TaxBracketBreakdown {
  takeOutSubtotal: number;
  takeOutTax: number;
  dineInSubtotal: number;
  dineInTax: number;
}

// total_tax_8/_10 are tax-INCLUSIVE bracket totals — the amount each bracket
// rate was charged on — and tax_amount_8/_10 is the tax alone within them. Both
// the order path and a split preview follow that contract, so the base is their
// difference. The tax is never re-derived from the rate here: that calculation
// belongs to the backend, which applies the restaurant's
// truncate/round-up/round-off setting to it.
export const getTaxBracketBreakdown = ({
  total_tax_8,
  total_tax_10,
  tax_amount_8,
  tax_amount_10,
}: TaxBracketSource = {}): TaxBracketBreakdown => {
  const takeOutTax = Number(tax_amount_8 || 0);
  const dineInTax = Number(tax_amount_10 || 0);

  return {
    takeOutSubtotal: Number(total_tax_8 || 0) - takeOutTax,
    takeOutTax,
    dineInSubtotal: Number(total_tax_10 || 0) - dineInTax,
    dineInTax,
  };
};

// The subtotal/tax_price stored on an order document are the sums of per-item
// rounded figures; adding them up across base + sub-orders accumulates that
// rounding and drifts from what the backend, the cashier and the receipt show
// (`orderRecalculationCashier` rounds the tax once per inclusive bracket). The
// totals to display are therefore the bracket rows themselves — every item is
// taxed at 8% or 10%, so the brackets are the whole order.
export const getOrderNetTotals = (source: TaxBracketSource = {}) => {
  const breakdown = getTaxBracketBreakdown(source);

  return {
    subtotal: breakdown.dineInSubtotal + breakdown.takeOutSubtotal,
    tax: breakdown.dineInTax + breakdown.takeOutTax,
  };
};
